import aiScreenLevels from './aiScreenLevels';

import type IAiChatScreen from 'components/AiChat/interfaces/IAiChatScreen';

/**
 * The API rejects a `currentScreen` longer than this. Mirrors `MaxLength(200)` on the backend
 * `ChatContextDto`. Change both together.
 * @see [12.8 Change a limit](../../docs/mockups/ai-agents/ai-chat/ATT-144_AI_Chat_Assistant.md)
 */
export const CURRENT_SCREEN_MAX_LENGTH = 200;

/** Between a screen and the sub-screen open over it. */
const SUB_SCREEN_SEPARATOR = ' › ';

const truncate = (line: string): string => (line.length > CURRENT_SCREEN_MAX_LENGTH
  ? `${line.slice(0, CURRENT_SCREEN_MAX_LENGTH - 1).trimEnd()}…`
  : line);

/**
 * Writes the one line the assistant is told about where the user is.
 *
 * The levels follow one another by name, the screen first, and the screen's url closes the line —
 * `Value Chain Map "Coffee supply chain" › Add product (/company-map/42?tab=bom)`. When the line
 * runs past what the API accepts the url is the first to go, being the part the names already
 * cover. Nothing is written for a screen with no name.
 */
export default function formatAiCurrentScreen(screen: IAiChatScreen): string {
  const levels = aiScreenLevels(screen);

  if (!levels.length) {
    return '';
  }

  const line = levels.map((level) => level.name).join(SUB_SCREEN_SEPARATOR);
  const lineWithUrl = screen.url ? `${line} (${screen.url})` : line;

  return lineWithUrl.length > CURRENT_SCREEN_MAX_LENGTH ? truncate(line) : lineWithUrl;
}
